import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/htl-part/src/environments/environment";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

export class Airport {
    id: number;
    code: string;
    city: string;
    name: string;
    position: number;
}

enum EndpointRoutes {
    GET_AIRPORTS = "airport/get",
}

@Injectable({
    providedIn: "root",
})
export class AirportAutocompleteSearchService {
    constructor(private _http: HttpClient) {}

    public searchAirports(filter: { name: string } = { name: "" }): Observable<Airport[]> {
        let params = new HttpParams();
        params = params.append("name", filter.name);
        return this._http.get<Airport[]>(environment.serverUrl + EndpointRoutes.GET_AIRPORTS, { params }).pipe(
            tap((response: Airport[]) => {
                return response;
            }),
        );
    }
}
